import { render, staticRenderFns } from "./LightFeedback.vue?vue&type=template&id=63f5195e&scoped=true&"
import script from "./LightFeedback.vue?vue&type=script&lang=js&"
export * from "./LightFeedback.vue?vue&type=script&lang=js&"
import style0 from "./LightFeedback.vue?vue&type=style&index=0&id=63f5195e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5195e",
  null
  
)

export default component.exports